import { PageExtensionNotInstalled } from './PageExtensionNotInstalled';

export default PageExtensionNotInstalled;
